import axios from 'axios';
import { store } from './store';
import { userActions } from '../actions/user.actions';

const client = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 90000,
});

// Add authorization header
client.interceptors.request.use(
  async config => {
    const token = JSON.parse(localStorage.getItem('token'));

    // Add token if set
    if (token && token.access_token) {
      config.headers.authorization = `Bearer ${token.access_token}`;
    }    
    config.headers.pragma = 'no-cache';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Tracks whether we are already handling an expired session, so that a burst of
// parallel requests all returning 401 only triggers a single logout + toast.
let handlingSessionExpiry = false;

// Add 401 interceptor check
client.interceptors.response.use(
  response => {
    // A successful response means we have a valid session again (e.g. after
    // re-login), so allow the next expiry to notify the user once more.
    handlingSessionExpiry = false;
    return response
  },
  error => {
    if (error.response && 401 === error.response.status) {
      const alreadyHandling = handlingSessionExpiry;
      handlingSessionExpiry = true;

      if (!alreadyHandling) {
        const { dispatch } = store;
        dispatch(userActions.logout());
      }

      // Signal that the redirect to login was caused by an expired/invalid
      // session so the UI can show a friendly message instead of a generic
      // error. `silent` suppresses the toast for the duplicate 401s that follow
      // the first one in a burst of parallel requests.
      return Promise.reject({ sessionExpired: true, silent: alreadyHandling });
    }
    return Promise.reject(error);
  }
);

export default client;
